import React from 'react';
import { publicAssetPath } from '../utils/publicAssetPath';

type AspenHealthLogoProps = {
  /** login: auth card; sidebar: compact sidebar header */
  variant?: 'login' | 'sidebar';
  /** Show "STAFF / PORTAL" beside (login) or below (sidebar) the logo */
  showPortalLabel?: boolean;
  className?: string;
};

export function AspenHealthLogo({
  variant = 'login',
  showPortalLabel = false,
  className,
}: AspenHealthLogoProps) {
  const image = (
    <img
      src={publicAssetPath('/ASP_Network_wide.png')}
      alt="Aspen Health"
      className={[
        'aspen-health-logo',
        variant === 'sidebar' ? 'aspen-health-logo--sidebar' : 'aspen-health-logo--login',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );

  if (!showPortalLabel) {
    return image;
  }

  if (variant === 'sidebar') {
    return (
      <div className="aspen-health-brand aspen-health-brand--sidebar">
        {image}
        <p className="aspen-health-brand__subtitle">Staff portal</p>
      </div>
    );
  }

  return (
    <div className="aspen-health-brand aspen-health-brand--login">
      {image}
      <div className="aspen-health-brand__divider" aria-hidden />
      <div className="aspen-health-brand__label">
        <span>STAFF</span>
        <span>PORTAL</span>
      </div>
    </div>
  );
}
